/*
* @Author: 曹俊杰
* @Date: 2022-05-10 17:52:49
* @Module: 三要素核查
*/
<template>
  <div class="inspect">
      <div class="left">
          <listMenu v-for="item in menuList" :itemData="item" :key="item.name" pathPrefix="inspect"/>
      </div>
      <div class="right">
          <keep-alive>
              <router-view />
          </keep-alive>
      </div>
  </div>
</template>
<script>
import listMenu from '@/components/listMenu/listMenu.vue';
export default {
  components: {
      listMenu
  },
  data() {
    return {
      menuList: [
        {
          title: '风险排查',
          name: 'inspectHome',
          icon: 'el-icon-ali-fengxianpaicha'
        },
        {
          title: '排查记录',
          name: 'inspectList',
          icon: 'el-icon-ali-paichajilu',
          authority: []
        }
      ]
    };
  },
}
</script>
<style lang='scss' scoped>
.inspect {
  @include contentStyle2;
}
</style>